import { has } from 'lodash'

function mapLabelFor<D, T>(data: D, tags: T) {
  return (pattern: string) => {
    return pattern
      ? pattern.replace(/#[^#]+#/g, function(substring: string): string {
          return has(tags, substring) ? tags[substring].map(data) : substring
        })
      : pattern
  }
}

export default mapLabelFor
